export class SecureUploaderClientConfig {
  secureUploaderServiceUrl = '';
  extraHeaders?: { [header: string]: string | string[] }; // Same typing as HttpHeaders from Angular - https://angular.io/api/common/http/HttpHeaders
}
